class DimensionRange extends HTMLElement {
    constructor() {
        super();
        this.dimension = this.dataset.dimension;
        this.productsList = document.getElementById('ProductsList');

        this.rangeMin = this.querySelector('.facet-range__min');
        this.rangeMax = this.querySelector('.facet-range__max');

        // Get inputs more reliably
        const inputs = this.querySelectorAll('.facet-range__input');
        this.inputMin = inputs[0];
        this.inputMax = inputs[1];

        this.rangeWrapper = this.querySelector('.facet-range-wrapper');

        if (this.productsList) {
            this.init();
        }
    }

    calculateMinMax() {
        const productColumns = this.productsList.querySelectorAll('.product-column');
        let min = Infinity;
        let max = -Infinity;

        productColumns.forEach(column => {
            let value;

            switch (this.dimension) {
                case 'length':
                    value = parseInt(column.dataset.variantLength);
                    break;
                case 'width':
                    value = parseInt(column.dataset.variantWidth);
                    break;
                case 'height':
                    value = parseInt(column.dataset.variantHeight);
                    break;
                case 'price':
                    value = parseInt(column.dataset.variantPrice); // This is in pence
                    break;
            }

            if (value && !isNaN(value)) {
                min = Math.min(min, value);
                max = Math.max(max, value);
            }
        });

        // If no valid values found, use defaults
        if (min === Infinity) min = 0;
        if (max === -Infinity) max = this.dimension === 'price' ? 15000 : 1000;

        // Round to nice numbers
        min = Math.floor(min / 100) * 100; // Round down to nearest 100
        max = Math.ceil(max / 100) * 100; // Round up to nearest 100

        return {
            min,
            max
        };
    }

    init() {
        // Calculate actual min/max from products
        const {
            min,
            max
        } = this.calculateMinMax();

        // Update range slider attributes
        this.rangeMin.min = min;
        this.rangeMin.max = max;
        this.rangeMin.value = min;
        this.rangeMax.min = min;
        this.rangeMax.max = max;
        this.rangeMax.value = max;

        // Load values from URL on page load
        this.loadFromURL();

        // Sync range sliders with inputs
        this.rangeMin.addEventListener('input', () => this.updateFromRange());
        this.rangeMax.addEventListener('input', () => this.updateFromRange());
        this.inputMin.addEventListener('change', () => this.updateFromInput());
        this.inputMax.addEventListener('change', () => this.updateFromInput());


        // Set initial values if not loaded from URL - convert pence to pounds for price
        if (this.dimension === 'price') {
            // Always convert pence to pounds for price dimension
            this.inputMin.value = Math.round(parseInt(this.rangeMin.value) / 100);
            this.inputMax.value = Math.round(parseInt(this.rangeMax.value) / 100);
            // Update input attributes too
            this.inputMin.min = Math.round(min / 100);
            this.inputMin.max = Math.round(max / 100);
            this.inputMax.min = Math.round(min / 100);
            this.inputMax.max = Math.round(max / 100);
        } else {
            if (!this.inputMin.value) this.inputMin.value = this.rangeMin.value;
            if (!this.inputMax.value) this.inputMax.value = this.rangeMax.value;
            this.inputMin.min = min;
            this.inputMin.max = max;
            this.inputMax.min = min;
            this.inputMax.max = max;
        }

        this.updateRangeVisual();

        // Update filter count on page load
        this.updateActiveFilterCount();

        // Update accordion state based on active filters
        this.updateAccordionState();
    }

    loadFromURL() {
        const params = new URLSearchParams(window.location.search);
        const minParam = params.get(`${this.dimension}_min`);
        const maxParam = params.get(`${this.dimension}_max`);

        if (minParam) {
            this.rangeMin.value = minParam;
            // Convert pence to pounds for price inputs
            this.inputMin.value = this.dimension === 'price' ? Math.round(minParam / 100) : minParam;
        }
        if (maxParam) {
            this.rangeMax.value = maxParam;
            // Convert pence to pounds for price inputs
            this.inputMax.value = this.dimension === 'price' ? Math.round(maxParam / 100) : maxParam;
        }
    }

    updateFromRange() {
        console.log('updateFromRange called for:', this.dimension);

        let minVal = parseInt(this.rangeMin.value);
        let maxVal = parseInt(this.rangeMax.value);

        // Prevent overlap
        const minGap = this.dimension === 'price' ? 100 : 10;
        if (minVal > maxVal - minGap) {
            minVal = maxVal - minGap;
            this.rangeMin.value = minVal;
        }

        // For price, convert pence to pounds for display (whole pounds)
        if (this.dimension === 'price') {
            this.inputMin.value = Math.round(minVal / 100);
            this.inputMax.value = Math.round(maxVal / 100);
        } else {
            this.inputMin.value = minVal;
            this.inputMax.value = maxVal;
        }

        this.updateRangeVisual();
        this.updateURL();
        this.filterProducts();
    }

    updateFromInput() {
        console.log('updateFromInput called for:', this.dimension);
        console.log('Input values - min:', this.inputMin.value, 'max:', this.inputMax.value);

        let minVal, maxVal;

        if (this.dimension === 'price') {
            // Convert pounds to pence for internal storage (multiply by 100)
            // Use current range value as fallback, not 0
            minVal = this.inputMin.value ? Math.round(parseFloat(this.inputMin.value) * 100) : parseInt(this.rangeMin.value);
            maxVal = this.inputMax.value ? Math.round(parseFloat(this.inputMax.value) * 100) : parseInt(this.rangeMax.value);
        } else {
            minVal = parseInt(this.inputMin.value) || parseInt(this.rangeMin.value);
            maxVal = parseInt(this.inputMax.value) || parseInt(this.rangeMax.value);
        }

        // Clamp values to min/max
        minVal = Math.max(parseInt(this.rangeMin.min), Math.min(minVal, parseInt(this.rangeMax.max)));
        maxVal = Math.max(parseInt(this.rangeMin.min), Math.min(maxVal, parseInt(this.rangeMax.max)));

        // Prevent overlap
        const minGap = this.dimension === 'price' ? 100 : 10;
        if (minVal > maxVal - minGap) {
            minVal = maxVal - minGap;
        }

        // Update range sliders (in pence for price)
        this.rangeMin.value = minVal;
        this.rangeMax.value = maxVal;

        // Update input display (back to pounds for price)
        if (this.dimension === 'price') {
            this.inputMin.value = Math.round(minVal / 100);
            this.inputMax.value = Math.round(maxVal / 100);
        } else {
            this.inputMin.value = minVal;
            this.inputMax.value = maxVal;
        }

        this.updateRangeVisual();
        this.updateURL();
        this.filterProducts();
    }

    updateRangeVisual() {
        const min = parseInt(this.rangeMin.min);
        const max = parseInt(this.rangeMax.max);
        const minVal = parseInt(this.rangeMin.value);
        const maxVal = parseInt(this.rangeMax.value);

        const minPercent = ((minVal - min) / (max - min)) * 100;
        const maxPercent = ((maxVal - min) / (max - min)) * 100;

        this.rangeWrapper.style.setProperty('--range-min', `${minPercent}%`);
        this.rangeWrapper.style.setProperty('--range-max', `${maxPercent}%`);
    }

    updateURL() {
        const params = new URLSearchParams(window.location.search);
        const minVal = parseInt(this.rangeMin.value);
        const maxVal = parseInt(this.rangeMax.value);
        const defaultMin = parseInt(this.rangeMin.min);
        const defaultMax = parseInt(this.rangeMax.max);

        // Only add to URL if different from defaults
        if (minVal !== defaultMin) {
            params.set(`${this.dimension}_min`, minVal);
        } else {
            params.delete(`${this.dimension}_min`);
        }

        if (maxVal !== defaultMax) {
            params.set(`${this.dimension}_max`, maxVal);
        } else {
            params.delete(`${this.dimension}_max`);
        }

        // Update URL without page reload
        const newURL = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
        window.history.replaceState({}, '', newURL);

        // Update the active filter count
        this.updateActiveFilterCount();

        // Update accordion state based on active filters
        //this.updateAccordionState();
    }

    filterProducts() {
        // Trigger filtering across all dimensions
        const event = new CustomEvent('dimension-filter-change', {
            bubbles: true,
            detail: {
                dimension: this.dimension
            }
        });
        this.dispatchEvent(event);
    }

    reset() {
        // Reset range sliders to their min/max
        this.rangeMin.value = this.rangeMin.min;
        this.rangeMax.value = this.rangeMax.max;

        // Reset inputs - convert pence to pounds for price
        if (this.dimension === 'price') {
            this.inputMin.value = Math.round(parseInt(this.rangeMin.min) / 100);
            this.inputMax.value = Math.round(parseInt(this.rangeMax.max) / 100);
        } else {
            this.inputMin.value = this.rangeMin.min;
            this.inputMax.value = this.rangeMax.max;
        }

        this.updateRangeVisual();
        this.updateURL();
        this.filterProducts();

        // Update the active filter count
        this.updateActiveFilterCount();
    }

    updateActiveFilterCount() {
        const container = document.querySelector('[data-dimension-filters]') || this.closest('form');
        const allFilters = document.querySelectorAll('dimension-range');
        
        // Get wall type count from URL (always accurate)
        const params = new URLSearchParams(window.location.search);
        const wallTypeCount = params.getAll('wall_type').length;
        
        let activeCount = 0;
        
        allFilters.forEach(filter => {
            if (!filter.rangeMin || !filter.rangeMax) {
                return;
            }
            const minVal = parseInt(filter.rangeMin.value);
            const maxVal = parseInt(filter.rangeMax.value);
            const defaultMin = parseInt(filter.rangeMin.min);
            const defaultMax = parseInt(filter.rangeMax.max);
            
            if (minVal !== defaultMin || maxVal !== defaultMax) {
                activeCount++;
            }
        });
        
        activeCount += wallTypeCount;
        
        const facetCounts = document.querySelectorAll('facet-count');
        
        facetCounts.forEach(facetCount => {
            facetCount.textContent = `(${activeCount})`;
            
            if (activeCount > 0) {
                facetCount.removeAttribute('hidden');
            } else {
                facetCount.setAttribute('hidden', '');
            }
        });
        
        updateFilterCountBadge(activeCount);
    }

    updateAccordionState() {
        const details = this.closest('details');
        if (!details) return;
        
        const minVal = parseInt(this.rangeMin.value);
        const maxVal = parseInt(this.rangeMax.value);
        const defaultMin = parseInt(this.rangeMin.min);
        const defaultMax = parseInt(this.rangeMax.max);
        
        // Open accordion if filter is active
        if (minVal !== defaultMin || maxVal !== defaultMax) {
            details.setAttribute('open', '');
            details.setAttribute('aria-expanded', 'true');
        } else {
            details.removeAttribute('open');
            details.setAttribute('aria-expanded', 'false');
        }

        // Also check wall strength accordion
        const params = new URLSearchParams(window.location.search);
        const wallTypes = params.getAll('wall_type');
        const wallAccordion = document.querySelector('[data-filter="wall-type"]');
        
        if (wallAccordion) {
            if (wallTypes.length > 0) {
                wallAccordion.setAttribute('open', '');
                wallAccordion.setAttribute('aria-expanded', 'true');
            } else {
                wallAccordion.removeAttribute('open');
                wallAccordion.setAttribute('aria-expanded', 'false');
            }
        }
    }


}

customElements.define('dimension-range', DimensionRange);

// Global filter coordinator
function updateDimensionFilters() {
    const productsList = document.getElementById('ProductsList');
    if (!productsList) return;

    const lengthFilter = document.querySelector('[data-dimension="length"]');
    const widthFilter = document.querySelector('[data-dimension="width"]');
    const heightFilter = document.querySelector('[data-dimension="height"]');
    const priceFilter = document.querySelector('[data-dimension="price"]');
    const wallCheckboxes = document.querySelectorAll('[data-wall-filter]:checked');

    // Check if each filter has been adjusted from defaults
    const lengthActive = lengthFilter && (
        parseInt(lengthFilter.rangeMin.value) !== parseInt(lengthFilter.rangeMin.min) ||
        parseInt(lengthFilter.rangeMax.value) !== parseInt(lengthFilter.rangeMax.max)
    );

    const widthActive = widthFilter && (
        parseInt(widthFilter.rangeMin.value) !== parseInt(widthFilter.rangeMin.min) ||
        parseInt(widthFilter.rangeMax.value) !== parseInt(widthFilter.rangeMax.max)
    );

    const heightActive = heightFilter && (
        parseInt(heightFilter.rangeMin.value) !== parseInt(heightFilter.rangeMin.min) ||
        parseInt(heightFilter.rangeMax.value) !== parseInt(heightFilter.rangeMax.max)
    );

    const priceActive = priceFilter && (
        parseInt(priceFilter.rangeMin.value) !== parseInt(priceFilter.rangeMin.min) ||
        parseInt(priceFilter.rangeMax.value) !== parseInt(priceFilter.rangeMax.max)
    );

    const lengthRange = lengthFilter ? [
        parseInt(lengthFilter.rangeMin.value),
        parseInt(lengthFilter.rangeMax.value)
    ] : [50, 1000];

    const widthRange = widthFilter ? [
        parseInt(widthFilter.rangeMin.value),
        parseInt(widthFilter.rangeMax.value)
    ] : [50, 1000];

    const heightRange = heightFilter ? [
        parseInt(heightFilter.rangeMin.value),
        parseInt(heightFilter.rangeMax.value)
    ] : [50, 1000];

    const priceRange = priceFilter ? [
        parseInt(priceFilter.rangeMin.value),
        parseInt(priceFilter.rangeMax.value)
    ] : [0, 999999];

    const activeWallTypes = Array.from(wallCheckboxes).map(cb => cb.dataset.wallFilter);

    const productColumns = productsList.querySelectorAll('.product-column');
    let visibleCount = 0;

    productColumns.forEach(column => {
        const length = parseInt(column.dataset.variantLength);
        const width = parseInt(column.dataset.variantWidth);
        const height = parseInt(column.dataset.variantHeight);
        const price = parseFloat(column.dataset.variantPrice);
        const wallType = column.dataset.wallType;
        const matchesWallType = activeWallTypes.length === 0 || activeWallTypes.includes(wallType);

        // Only check filters that are active
        const matchesLength = !lengthActive || (length >= lengthRange[0] && length <= lengthRange[1]);
        const matchesWidth = !widthActive || (width >= widthRange[0] && width <= widthRange[1]);
        const matchesHeight = !heightActive || (height >= heightRange[0] && height <= heightRange[1]);
        const matchesPrice = !priceActive || (price >= priceRange[0] && price <= priceRange[1]);

        if (matchesLength && matchesWidth && matchesHeight && matchesPrice && matchesWallType) {
            column.style.display = '';
            visibleCount++;
        } else {
            column.style.display = 'none';
        }
    });

    // Update product count
    const countElement = document.getElementById('ProductCount');
    if (countElement) {
        countElement.textContent = `${visibleCount} products`;
    }

    // Update active filter pills and count badge
    updateActiveFilterPills(lengthActive, widthActive, heightActive, priceActive, activeWallTypes, lengthFilter, widthFilter, heightFilter, priceFilter);
}

function updateActiveFilterPills(lengthActive, widthActive, heightActive, priceActive, activeWallTypes, lengthFilter, widthFilter, heightFilter, priceFilter) {

    const container = document.getElementById('CustomFiltersActive');
    if (!container) return;

    const pills = [];
    let activeCount = 0;

    if (priceActive) {
        const minPrice = (parseInt(priceFilter.rangeMin.value) / 100).toFixed(2);
        const maxPrice = (parseInt(priceFilter.rangeMax.value) / 100).toFixed(2);
        pills.push(createFilterPill('Price', `£${minPrice}`, `£${maxPrice}`, 'price'));
        activeCount++;
    }

    if (lengthActive) {
        pills.push(createFilterPill('Length', lengthFilter.inputMin.value + 'mm', lengthFilter.inputMax.value + 'mm', 'length'));
        activeCount++;
    }

    if (widthActive) {
        pills.push(createFilterPill('Width', widthFilter.inputMin.value + 'mm', widthFilter.inputMax.value + 'mm', 'width'));
        activeCount++;
    }

    if (heightActive) {
        pills.push(createFilterPill('Height', heightFilter.inputMin.value + 'mm', heightFilter.inputMax.value + 'mm', 'height'));
        activeCount++;
    }

    if (activeWallTypes.length > 0) {
        activeWallTypes.forEach(wallType => {
            pills.push(createFilterPill('Wall Type', wallType, '', 'wall-type', wallType));
            activeCount++;
        });
    }

    // Add "Clear all" if any filters active
    if (activeCount > 0) {
        pills.push(`
      <a href="#" class="facet-clear-all btn--link" data-clear-all>
        Clear all
      </a>
    `);
    }

    if (pills.length > 0) {
        container.innerHTML = pills.join('');
        container.style.display = 'flex';

        // Add event listeners to remove buttons
        container.querySelectorAll('[data-remove-filter]').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const dimension = btn.dataset.removeFilter;
                const wallTypeValue = btn.dataset.wallTypeValue;
                
                if (dimension === 'wall-type' && wallTypeValue) {
                    // Uncheck the specific wall type checkbox
                    const checkbox = document.querySelector(`[data-wall-filter="${wallTypeValue}"]`);
                    if (checkbox) {
                        checkbox.checked = false;
                        updateWallTypeURL();
                        updateDimensionFilters();
                        updateFilterCount();
                    }
                } else {
                    // Reset dimension filter
                    const filter = document.querySelector(`[data-dimension="${dimension}"]`);
                    if (filter) filter.reset();
                }
            });
        });
        // Add event listener to clear all
        const clearAll = container.querySelector('[data-clear-all]');
        if (clearAll) {
            clearAll.addEventListener('click', (e) => {
                e.preventDefault();
                [lengthFilter, widthFilter, heightFilter, priceFilter].forEach(filter => {
                    if (filter) filter.reset();
                });
                // Reset wall type checkboxes
                document.querySelectorAll('[data-wall-filter]').forEach(cb => {
                    cb.checked = false;
                });
                updateWallTypeURL();
                updateDimensionFilters();
                updateFilterCount();
            });
        }

    } else {
        container.style.display = 'none';
    }

    // Update filter count badge on drawer button
    updateFilterCountBadge(activeCount);
}

function updateFilterCountBadge(count) {
    // Find the filter drawer button - adjust selector based on your theme
    const drawerButton = document.querySelector('[data-facet-drawer-button], .facets-drawer__button, #FacetsDrawerButton');

    if (!drawerButton) return;

    let badge = drawerButton.querySelector('.facets-drawer__badge, .filter-count-badge');

    if (count > 0) {
        if (!badge) {
            badge = document.createElement('span');
            badge.className = 'facets-drawer__badge';
            drawerButton.appendChild(badge);
        }
        badge.textContent = count;
        badge.style.display = 'inline-block';
    } else if (badge) {
        badge.style.display = 'none';
    }
}

function createFilterPill(label, min, max, dimension, wallTypeValue) {
    // For wall type, only show the single value
    const displayText = dimension === 'wall-type' 
        ? `${label}: ${min}` 
        : `${label}: ${min} - ${max}`;
    
    // Add wall type value as data attribute if provided
    const wallTypeAttr = wallTypeValue ? `data-wall-type-value="${wallTypeValue}"` : '';
    
    return `
    <a class="facet-remove btn btn--secondary flex relative" href="#" data-remove-filter="${dimension}" ${wallTypeAttr}>
      <div class="btn__text flex items-center justify-between gap-2">
        <div class="facet-title text-wrap flex items-center gap-2">
          ${displayText}
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close icon--extra-small icon--thick" fill="none" viewBox="0 0 24 24">
          <path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18.75 18.8544L5.25 5.13496" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </a>
  `;
}

function updateWallTypeURL() {
  const params = new URLSearchParams(window.location.search);
  const wallCheckboxes = document.querySelectorAll('[data-wall-filter]:checked');
  
  // Remove existing wall_type parameters
  params.delete('wall_type');
  
  // Add checked wall types
  if (wallCheckboxes.length > 0) {
    wallCheckboxes.forEach(checkbox => {
      params.append('wall_type', checkbox.dataset.wallFilter);
    });
  }
  
  // Update URL without page reload
  const newURL = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
  window.history.replaceState({}, '', newURL);
}

function updateFilterCount() {
  setTimeout(() => {
    const anyFilter = document.querySelector('dimension-range');
    if (anyFilter && anyFilter.updateActiveFilterCount) {
      anyFilter.updateActiveFilterCount();
    }
  }, 50);
}

document.addEventListener('dimension-filter-change', updateDimensionFilters);

// Run on page load to handle URL parameters
document.addEventListener('DOMContentLoaded', () => {
  // Read wall_type from URL and check boxes FIRST
  const params = new URLSearchParams(window.location.search);
  const wallTypes = params.getAll('wall_type');
  
  if (wallTypes.length > 0) {
    wallTypes.forEach(wallType => {
      const checkbox = document.querySelector(`[data-wall-filter="${wallType}"]`);
      if (checkbox) {
        checkbox.checked = true;
      }
    });
  }

  // Set initial accordion states based on active filters
  const allFilters = document.querySelectorAll('dimension-range');
  allFilters.forEach(filter => {
    if (filter.updateAccordionState) {
      filter.updateAccordionState();
    }
  });

  updateDimensionFilters();
  
    const wallCheckboxes = document.querySelectorAll('[data-wall-filter]');
        wallCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
            updateWallTypeURL();
            document.dispatchEvent(new CustomEvent('dimension-filter-change'));
            updateFilterCount();
        });
    });

});